import { Subscription } from 'rxjs';
import { MasterVisualizarPerfilComponent } from './../visualizar-perfil/master-visualizar-perfil.component';
import { PermissionsType } from '../../../custom-shared/enums/permissions-type.enum';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MasterConsultaProfileService } from './master-consulta-perfil.service';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { MatSort } from '@angular/material/sort';

import { MasterHomCreateProfileComponent } from '../master-create-profile/master-home-create-profile.component';
import { MatTableDataSource } from '@angular/material/table';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-consulta-perfil',
  templateUrl: './master-consulta-perfil.component.html',
  styleUrls: ['./master-consulta-perfil.component.scss'],
})
export class MasterConsultaProfileComponent implements OnInit {
  subscription: Subscription;

  profiles: any;
  filterAutoComplete: any;
  dialogConfig: any;
  profileFilter: any;
  clientStatus = false;
  editar: boolean = false;
  criar: boolean = false;
  alldata: any;
  @ViewChild('sortData', { static: false }) sortData: MatSort;
  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private _masterProfileService: MasterConsultaProfileService,
    private dialog: MatDialog,
    private customAuthenticationService: CustomAuthenticationService,
    private profileService: ProfileManagerService,
  ) { }

  ngOnInit() {
    this.getProfiles(this.clientStatus);
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';

    this.editar = this.customAuthenticationService.hasPermission(
      PermissionsType.editarPerfilDeAcesso,
    );
    this.criar = this.customAuthenticationService.hasPermission(
      PermissionsType.criarPerfilDeAcesso,
    );

  }

  sortProfiles(result) {
    this.profiles = result.map((pro, i) => {
      if (pro.description == null) {
        pro.description = '';
      }
    });
    this.profiles = this.profiles.sort((a, b) => {
      return a.profile.toLowerCase().trim() > b.profile.toLowerCase().trim() ? 1 : -1;
    });
    this.proxyAutoComplete();
  }


  sortValues(values) {
    return values.sort((a, b) => {
      if (a.profile == null) {
        a.profile = '';
      }
      if (b.profile == null) {
        b.profile = '';
      }
      if (a.description == null) {
        a.description = '';
      }
      if (b.description == null) {
        b.description = '';
      }
      return a.profile.toLowerCase() > b.profile.toLowerCase() ? 1 : -1;
    });
  }

  getProfiles(status) {
    if (status == undefined) {
      status = false
    }
    const payload = { activesOnly: status };
    const observable = this._masterProfileService.getProfiles(payload);
    observable.subscribe(response => {
      this.profiles = this.sortValues(response);

      this.profiles = new MatTableDataSource<any>(this.profiles);
      this.alldata = this.profiles
      this.profiles.sortingDataAccessor = (data, sortHeaderId) =>
        typeof data[sortHeaderId] === 'string'
          ? data[sortHeaderId]
            .toLowerCase()
          : data[sortHeaderId]


      this.profiles.sort = this.sortData;
      this.sortData.disableClear = true;
      if (this.profileFilter != null) {
        this.profiles.filter = this.profileFilter

      }
    });
  }

  toggleStatus() {
    this.clientStatus = !this.clientStatus;
    this.getProfiles(this.clientStatus);
  }

  async filterUsers(event: Event) {
    this.profileFilter = (event.target as HTMLInputElement).value;

    this.profiles.filter = this.profileFilter

    // const payload = `{"activesOnly": "${this.clientStatus}", "name": "${this.profileFilter}"}`;
    // if (this.profileFilter.length > 0 && this.profileFilter.length % 2 == 0) {
    //   const filteredData = await this._masterProfileService.getProfileSearch(payload);
    //   this.profiles = filteredData;
    //   this.filterAutoComplete = filteredData;
    // } else if (this.profileFilter.length == 0) {
    //   const filteredData = await this._masterProfileService.getProfileSearch(payload);
    //   this.profiles = filteredData;
    //   this.filterAutoComplete = [];
    // }
  }

  proxyAutoComplete(term = null) {
    if (!term) return;
    const complete = this.profiles.map(client => {
      return client
        .filter(prof => {
          return prof.profile != undefined;
        })
        .map(pro => {
          return pro.profile;
        });
    });
    this.filterAutoComplete = new Set(
      []
        .concat(...complete)
        .filter(ele => ele.toLowerCase().includes(term.toLowerCase())),
    );
  }

  openDialogVisualizarPerfil(id, description) {
    const dialogRef = this.dialog.open(
      MasterVisualizarPerfilComponent,
      this.dialogConfig,
    );
    dialogRef.componentInstance.id = id;
    dialogRef.componentInstance.description = description;
    dialogRef.afterClosed().subscribe(() => {
      this.getProfiles(this.clientStatus);
    });
  }

  openDialogCreateProfile() {
    const dialogRef = this.dialog.open(
      MasterHomCreateProfileComponent,
      this.dialogConfig,
    );

    dialogRef.beforeClosed().subscribe(() => {
      this.getProfiles(this.clientStatus);
    });
  }

  checkMasterProfilePermissions() {
    if (this.profileService.isMasterClient()) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
